/* eslint-disable react/prop-types */
import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

/**
 * Month/year-only picker — always displays as MM-YYYY.
 * Not a variant of MDDatePicker: kept as its own component so this behaviour
 * never leaks into the shared full-date picker used elsewhere in the app.
 * value    : string "YYYY-MM" or null
 * onChange : called with a "YYYY-MM" string, or null
 * inputRef/onKeyDown/inputProps : forwarded to the underlying TextField (e.g. for grid keyboard nav)
 */
export default function MDMonthYearPicker({
  value, onChange, label, disabled, size = 'small', sx = {},
  inputRef, onKeyDown, inputProps,
}) {
  const dayjsVal = value ? dayjs(value, 'YYYY-MM') : null;

  const handleChange = (newVal) => {
    if (!newVal || !newVal.isValid()) { onChange(null); return; }
    onChange(newVal.format('YYYY-MM'));
  };

  return (
    <DatePicker
      value={dayjsVal}
      onChange={handleChange}
      disabled={disabled}
      views={['year', 'month']}
      openTo="month"
      inputFormat="MM-YYYY"
      mask="__-____"
      renderInput={(params) => {
        const mergedInputRef = !inputRef ? params.inputRef : (el) => {
          if (typeof params.inputRef === 'function') params.inputRef(el);
          else if (params.inputRef) params.inputRef.current = el;
          if (typeof inputRef === 'function') inputRef(el);
          else if (inputRef) inputRef.current = el;
        };
        return (
          <TextField
            {...params}
            size={size}
            label={label}
            fullWidth
            inputRef={mergedInputRef}
            onKeyDown={onKeyDown}
            inputProps={{ ...params.inputProps, ...inputProps }}
            sx={{ '& .MuiOutlinedInput-root': { height: size === 'small' ? 34 : 44, fontSize: '0.82rem' }, ...sx }}
          />
        );
      }}
    />
  );
}
